function getNext24Hours() {
  const hours = [];
  for (let i = 0; i < 24; i++) {
    const date = new Date();
    date.setHours(date.getHours() + i);
    if (i >= 1) {
      date.setMinutes(0, 0, 0); // 设置分钟、秒和毫秒为0
    }
    hours.push((date.getHours() + "").padStart(2, "0") + ":" + (date.getMinutes() + "").padStart(2, "0"));
  }
  return hours;
}
export function getRandomNumber(min: number, max: number) {
  return Math.floor(Math.random() * (max - min + 1)) + min;
}
import { pxChangeVw } from "@/utils";
const BarChart: React.FC = _props => {
  const next24Hours = getNext24Hours().map((item, index) => (index === 0 ? "Current" : item));
  const dataArray = Array(24)
    .fill(null)
    .map(_item => getRandomNumber(1, 300));
  const maxNum = Math.max(...dataArray);
  const [containerWidth, setContainerWidth] = useState(0);
  const container = useRef<any>(null);
  useEffect(() => {
    setContainerWidth(container.current.scrollWidth);
  }, []);
  return (
    <div>
      <div
        className="w-full h-120 flex items-end overflow-y-hidden overflow-x-auto p-[16px_8px_32px] relative"
        ref={container}
        // @ts-ignore
        style={{ "--container-width": pxChangeVw(containerWidth + "px") }}
      >
        {next24Hours.map((item, index) => (
          <div key={index} className="h-full flex items-end">
            <div
              className="w-8 m-[0_16px] rounded-[8px_8px_0_0] bg-[#bcff7e] text-center color-[white] flex items-start justify-center relative"
              style={{ height: (dataArray[index] / maxNum) * 100 + "%" }}
            >
              <div className="text-10 absolute top-[-16px]">{dataArray[index]}</div>
              <div className="text-12 color-[#fff] absolute bottom-[-22px]">{item}</div>
            </div>
          </div>
        ))}

        <div className="w-[var(--container-width)] border-b-1 border-b-dashed border-b-[rgba(255,255,255,0.45)] absolute left-0 bottom-32"></div>
        <div className="w-[var(--container-width)] border-b-1 border-b-dashed border-b-[rgba(255,255,255,0.45)] absolute left-0 bottom-68"></div>
        <div className="w-[var(--container-width)] border-b-1 border-b-dashed border-b-[rgba(255,255,255,0.45)] absolute left-0 bottom-104"></div>
      </div>
      <div className="bg-[#1272b3] h-45 w-full absolute bottom-0 left-0 rounded-[0_0_10px_10px] h-60 flex justify-start items-center gap-x-16 p-[0_20px]">
        <div className="flex-[3] h-70% flex items-center gap-x-8">
          <div className="bg-[#bcff7e] w-6 h-full rounded-4"></div>
          <div className="h-full flex flex-col items-start">
            <p style={{ fontSize: pxChangeVw("16px") }}>Fair</p>
            <p style={{ fontSize: pxChangeVw("12px") }}>32 AQI</p>
          </div>
        </div>
        <div className="flex-[7] flex justify-start gap-x-8 gap-y-5">
          <div className="flex-[1] flex flex-col items-center">
            <p>32</p>
            <p className="text-10 color-[rgba(255,255,255,0.8)]">PM2.5</p>
          </div>
          <div className="flex-[1] flex flex-col items-center">
            <p>15</p>
            <p className="text-10 color-[rgba(255,255,255,0.8)]">PM10</p>
          </div>
          <div className="flex-[1] flex flex-col items-center">
            <p>17</p>
            <p className="text-10 color-[rgba(255,255,255,0.8)]">Q3</p>
          </div>
          <div className="flex-[1] flex flex-col items-center">
            <p>5</p>
            <p className="text-10 color-[rgba(255,255,255,0.8)]">NO2</p>
          </div>
        </div>
      </div>
    </div>
  );
};
export default BarChart;
